import { ManualTypeEnum } from '../../graphql/types';

export const manualsGroupTitles = {
  [ManualTypeEnum.Manual]: 'Инструкции',
  [ManualTypeEnum.Infographics]: 'Инфографика',
  [ManualTypeEnum.Video]: 'Видеоролики'
};
